/* eslint-disable react/prop-types */
import React from 'react';
import { Table, Typography } from 'antd';
import moment from 'moment';

const { Text } = Typography;

const LogDetailsTable = (props) => {
  const { dataList, columnList, showLogLoader, tableDated, onFetchLogDetails, totalCount } = props;

  return (
    <div>
      {dataList && dataList.length > 0 ? (
        <>
          <Text className="log-details-dated dated">
            Dated: {moment(tableDated.fromDate).format('DD MMM YYYY')}
          </Text>
          <div className="log-table-shell">
            {dataList && dataList.length > 0 ? (
              <>
                <Table
                  className="log-details-dashboard-table"
                  columns={columnList}
                  dataSource={dataList}
                  loading={showLogLoader}
                  pagination={{
                    className: 'heat-profile-pagination',
                    position: ['bottomCenter'],
                    showSizeChanger: true,
                    pageSizeOptions: ['10', '20', '50', '100'],
                    showTotal: (total, range) => `${range[0]}–${range[1]} of ${total} items`,
                    total: totalCount,
                    defaultPageSize: 20,
                    onChange: async (page, size) => {
                      var obj = {
                        fromDate: tableDated.fromDate,
                        toDate: tableDated.toDate,
                        sowId: tableDated.sowId,
                        pageSize: size,
                        pageIndex: page - 1,
                      };
                      sessionStorage.setItem(
                        'page',
                        JSON.stringify({
                          pageSize: size,
                          pageIndex: page - 1,
                        })
                      );
                      await onFetchLogDetails(obj);
                    },
                  }}
                  scroll={{ x: '100%', y: '100%' }}
                  components={{
                    header: {
                      cell: (cellProps) => (
                        <th style={{ maxWidth: '200px', whiteSpace: 'wrap', overflow: 'hidden' }}>
                          {cellProps.children}
                        </th>
                      ),
                    },
                  }}
                />
              </>
            ) : (
              <Table
                className="log-details-dashboard-table"
                loading={showLogLoader}
              />
            )}
          </div>
        </>
      ) : (
        <div className="log-table-shell">
          <Table
            className="log-details-dashboard-table"
            loading={showLogLoader}
          />
        </div>
      )}
    </div>
  );
};

export default LogDetailsTable;
